import Slider from '@templates/Components/Slider/Slider.js';

const PopupGallery = {

	init() {
		this.el = $('.popupGallery');
		this.images = $('[data-gallery]');
		if (!this.el.length || !this.images.length) return;

		this.slider = this.el.find('[block="slider"]');
		this.button = this.el.find('button.close');
		this.bind();
	},

	bind() {
		this.images.click((evt) => {
			this.prepare($(evt.currentTarget));
		});

		this.button.click(() => {
			this.slider.trigger('destroy.owl.carousel').empty().removeClass('owl-carousel owl-loaded owl-drag');
			this.el.find('.slider-remote').empty();
			this.el.removeClass('visible');
		});
	},

	prepare(image) {
		let current = 0;
		const gallery = image.data('gallery');
		const images = $('[data-gallery="' + gallery + '"]').find('img').clone(false, false);

		images.each((i, el) => {
			if($(el).attr('src') === $(image.find('img')).attr('src')) current = i;
			const src = $(el).attr('src').split('?')[0];
			$(el).attr('src', src);
		})

		images.appendTo(this.slider);
		this.el.find('.inner').attr('component', 'Slider');
		Slider.init();
		this.slider.trigger('to.owl.carousel', [current, 0]);
		this.el.addClass('visible');
	},

};

export default PopupGallery;